/**
 * Time helpers kept free of React/DOM. `timeUtc` returns the number of seconds
 * since the 2001-01-01 UTC reference epoch (matching the Swift/CoreFoundation
 * `timeIntervalSinceReferenceDate` used server-side).
 */
export const Time = {
  timeUtc(): number {
    return referenceEpochNow({ referenceDate: new Date(Date.UTC(2001, 0, 1)) });
  },
};
import { referenceEpochNow } from "app-base/runtime/time"
